import { render } from "./LabView.vue?vue&type=template&id=6012a8bd&scoped=true&bindings={}"
import script from "./LabView.vue?vue&type=script&lang=ts"
export * from "./LabView.vue?vue&type=script&lang=ts"

import "./LabView.vue?vue&type=style&index=0&id=6012a8bd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6012a8bd"

export default script